/**
 * Marcadores de "número ilustrativo — sem API ainda". O protótipo do painel (Google Stitch)
 * é ~70% aspiracional; onde o dado não existe, renderiza o visual e marca com isto.
 */

export function PlaceholderTag({ label = 'exemplo' }: { label?: string }) {
  return (
    <span
      title="Número ilustrativo — integração de dados em breve"
      className="font-label-sm text-label-sm px-space-2xs py-space-3xs rounded bg-surface-variant text-outline uppercase tracking-wider"
    >
      {label}
    </span>
  );
}

export function PlaceholderDot() {
  return (
    <span
      title="Número ilustrativo — integração de dados em breve"
      className="inline-block w-1.5 h-1.5 rounded-full bg-outline/60 ml-1.5 align-middle"
    />
  );
}

/** Faixa no topo de uma tela que ainda é 100% mockup (sem backend nenhum). */
export function DemoBanner({ children }: { children?: React.ReactNode }) {
  return (
    <div className="flex items-center gap-space-xs rounded-xl bg-[#f59e0b]/10 border border-[#f59e0b]/25 px-space-md py-space-sm font-label-sm text-label-sm text-[#f59e0b]">
      <MSymDot />
      <span>{children ?? 'Prévia do design — os números e listas desta tela são ilustrativos. A integração de dados vem depois.'}</span>
    </div>
  );
}

function MSymDot() {
  return <span className="material-symbols-outlined text-[16px] shrink-0">construction</span>;
}
